import { string } from 'yup';

const obj = {
  field: [
    {
      title: "Website URL",
      attr: "language",
      value: "",
      placeholder: "Topic or keyword",
      label: "Which language are you using, will enable markup highlights",
      type: "text",
      maxLength: 40,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Website URL is Required"),
      id: "websiteURL",
      // options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
      // max: 100,
      min: 3,
      required: true,
      error: "",
      example: `JavaScript`,
    },
  ],
  example: [
    {
      title: "Website URL",
      attr: "language",
      value: "https://www.facebook.com/",
      placeholder: "Topic or keyword",
      label: "Which language are you using, will enable markup highlights",
      type: "text",
      maxLength: 40,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Website URL is Required "),
      id: "websiteURL",
      // options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
      // max: 100,
      min: 3,
      required: true,
      error: "",
      example: `JavaScript`,
    },
  ],
  editor: {
    output: `1. Social media\n2. Networking\n3. Sharing content\n4. Connecting people\n5. Online communities\n6. Digital marketing\n7. Brand building\n8. Advertising campaigns\n9. Targeted audiences\n10. Social media analytics\n11. Engagement metrics\n12. User generated content\n13. Video streaming\n14 .Content sharing platforms\n15 .Data-driven insights `,
    
    
     
     
     
     
     
     
      
      
      
      					      	    
     
      
      
       
      
  },
};

export default obj;
